import { render, staticRenderFns } from "./PatientEmail.vue?vue&type=template&id=1b4c4776&scoped=true&"
import script from "./PatientEmail.vue?vue&type=script&lang=js&"
export * from "./PatientEmail.vue?vue&type=script&lang=js&"
import style0 from "./PatientEmail.vue?vue&type=style&index=0&id=1b4c4776&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c4776",
  null
  
)

export default component.exports